import React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import './css/Terms.css'
export default function Terms (props) {
  const { open, setopen } = props
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  }

  const handleClose = () => {
    setopen(false)
  }
  return (
    <div className='terms-modal'>
      <Modal
        open={open}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <div className='terms-box'>
            <div className='terms-text'>
              <h2>Terms of Service</h2>
              <h3>Greetings Users,</h3>

              <p>
                By accepting terms for the purchase of Anti-Virus Software
                Licenses, expressly agree to be bound by these Anti-Virus
                Software Standard Terms and Conditions (Standard Terms). Each
                Quote is subject to KeyCentrix’s acceptance and may be accepted
                or rejected by KeyCentrix in its sole discretion. Further, these
                Standard Terms and any Quote that subsequently refers to these
                Standard Terms are intended to and shall, collectively
                constitute one agreement. It is understood that each Quote will
                specify the current charges and costs for the Anti-Virus
                Software to be provided by KeyCentrix under this Agreement.
              </p>
              <h4>
                I Agree to the <span>Terms of Service </span>and I read the
                Privacy Notice.
              </h4>
              <div className='buttons'>
                <button className='btn red-btn' onClick={handleClose}>
                  Accept
                </button>
                <button className='btn gray-btn' onClick={handleClose}>
                  Decline
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}
